// calendarUtils.js

export const getDaysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();

export const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export function generateCalendarItems({
  original,
  selectedId,
  elements,
  startDay,
  year,
  month
}) {
  const daysInMonth = getDaysInMonth(year, month);
  const spacingX = original.width + 10;
  const spacingY = original.height + 10;
  const firstDay = new Date(year, month, 1).getDay();
  const offset = (firstDay - startDay + 7) % 7;
  const timestampBase = Date.now();

  const newItems = [];

  for (let i = 0; i < 7; i++) {
    const dayName = dayNames[(startDay + i) % 7];
    newItems.push({
      id: timestampBase + i,
      type: 'text',
      x: original.x + i * spacingX + 5,
      y: original.y - 30,
      text: dayName,
      fontSize: 14,
    });
  }

  let dayCounter = 1;
  for (let row = 0; row < 6; row++) {
    for (let col = 0; col < 7; col++) {
      const cellIndex = row * 7 + col;
      if (cellIndex < offset || dayCounter > daysInMonth) continue;

      const baseX = original.x + col * spacingX;
      const baseY = original.y + row * spacingY;
      const boxId = timestampBase + 1000 + dayCounter;

      newItems.push({
        ...original,
        id: boxId,
        x: baseX,
        y: baseY,
      });

      newItems.push({
        id: boxId + 100000,
        type: 'text',
        x: baseX + 5,
        y: baseY + 15,
        text: String(dayCounter),
        fontSize: 12,
      });

      dayCounter++;
    }
  }

  return newItems;
}
